import React, { useState } from 'react';
import { X } from 'lucide-react';
import { usePortal } from '../PortalAuth';
import { savePref } from '../prefs';
import { Card } from '../ui';

export const GRAPH_STYLES = [
  { id: 'costellazione', label: 'Costellazione', img: '/anteprime-grafo/Grafo_A_portale_chiaro.jpg' },
  { id: 'mappa', label: 'Mappa investigativa', img: '/anteprime-grafo/Grafo_B_portale_chiaro.jpg' },
  { id: 'anelli', label: 'Anelli radiali', img: '/anteprime-grafo/Grafo_C_portale_chiaro.jpg' },
  { id: 'bolle', label: 'Cluster a bolle', img: '/anteprime-grafo/Grafo_D_portale_chiaro.jpg' },
];
const valid = (s) => GRAPH_STYLES.some((g) => g.id === s);

export function useGraphStyle() {
  const { user } = usePortal();
  const saved = user?.preferences?.graph_style;
  const [style, setStyle] = useState(() => {
    const local = localStorage.getItem('bond_graph_style');
    return valid(local) ? local : valid(saved) ? saved : 'mappa';
  });
  const change = (s) => { if (s === style) return; setStyle(s); savePref('graph_style', s); };
  return [style, change];
}

export function GraphStyleSelect({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-1 p-1 border border-[#1F242C] rounded-sm" data-testid="graph-style-select">
      {GRAPH_STYLES.map((s) => (
        <button key={s.id} onClick={() => onChange(s.id)} data-testid={`graph-style-${s.id}`} aria-pressed={value === s.id}
          className={`px-3 h-8 text-xs rounded-sm transition-colors ${value === s.id ? 'bg-[#D4AF37] text-[#050505] font-semibold' : 'text-[#A3A3A3] hover:text-[#F2F2F2]'}`}>{s.label}</button>
      ))}
    </div>
  );
}

export function GroupPanel({ group, onClose }) {
  return (
    <Card className="p-6 absolute top-4 right-4 w-[min(360px,calc(100%-2rem))] max-h-[calc(100%-2rem)] overflow-y-auto bg-[#0B0D10]/95 backdrop-blur-xl z-10" data-testid="graph-group-panel">
      <button onClick={onClose} className="absolute top-4 right-4 text-[#5A5F67] hover:text-white" data-testid="graph-group-close"><X size={16} /></button>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-3">Soci raggruppati</p>
      <p className="font-heading text-lg text-[#F2F2F2] mb-1" data-testid="graph-group-name">{group.label}</p>
      <p className="text-xs text-[#8A8F97] mb-4">{group.rel}</p>
      {group.members.map((m) => (
        <div key={m.id} className="text-xs py-1.5 border-b border-[#1F242C] last:border-0 flex justify-between gap-3">
          <span className="text-[#E5E5E5] truncate">{m.label}</span><span className="text-[#8A8F97] shrink-0">{m.rel}</span>
        </div>
      ))}
    </Card>
  );
}
